
export function initializeHeaderScroll() {
    const header = document.querySelector('.site-header');
    
    if (!header) {
        return;
    }

    let isScrolled = false;
    
    function handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const shouldShowShadow = scrollTop > 10;
        
        if (shouldShowShadow && !isScrolled) {
            header.classList.add('scrolled');
            isScrolled = true;
        } else if (!shouldShowShadow && isScrolled) {
            header.classList.remove('scrolled');
            isScrolled = false;
        }
    }

    let ticking = false;
    
    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(handleScroll);
            ticking = true;
        }
    }
    
    function resetTicking() {
        ticking = false;
    }
    
    window.addEventListener('scroll', () => {
        requestTick();
        setTimeout(resetTicking, 16);
    }, { passive: true });
    
    handleScroll();
}